import { Divider } from "primereact/divider";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import { Description } from "../../../components/Description";
import styles from "../../../components/ListDescriptions/styles.module.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL, formatarCNPJ } from "../../../utils";

export function CadastralEmpresa({ cadastralEmpresaCnpj }: { cadastralEmpresaCnpj: any }) {
  const { t } = useTranslation();


  const formatarData = (item: any) => {

    return item.data_entrada_sociedade ? item.data_entrada_sociedade.substring(8, 10) + '/' + item.data_entrada_sociedade.substring(5, 7) + '/' + item.data_entrada_sociedade.substring(0, 4) : '';
  }


  return (

    <Panel header={t("cadastralEmpresa")}>


      <div>
        <Divider align="left">
          <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>

            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><rect x="3" y="5" width="6" height="6" rx="1" /><path d="m3 17 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" /></svg>
            <span style={{ paddingLeft: '0.5rem' }}>
              <b>Informações cadastrais</b>
            </span>
          </div>
        </Divider>
        <div className={styles.wrapper}>
          <div className={styles.gridContainer} style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
            <Description key={'cnpj'} label={t('cnpj')} value={formatarCNPJ(cadastralEmpresaCnpj.cnpj)} />
            <Description key={'nome'} label={t('razaoSocial')} value={cadastralEmpresaCnpj.razao_social} />
            <Description key={'fantasia'} label={t('nomeFantasia')} value={cadastralEmpresaCnpj.nome_fantasia} />
            <Description key={'tipo'} label={t('tipo')} value={cadastralEmpresaCnpj.tipo} />
            <Description key={'situacao'} label={t('situacao')} value={cadastralEmpresaCnpj.situacao} />
            <Description key={'data_abertura'} label={t('dataAbertura')} value={cadastralEmpresaCnpj.data_abertura ? cadastralEmpresaCnpj.data_abertura.substring(8, 10) + '/' + cadastralEmpresaCnpj.data_abertura.substring(5, 7) + '/' + cadastralEmpresaCnpj.data_abertura.substring(0, 4) : ''} />
            <Description key={'natureza'} label={t('naturezaJuridica')} value={cadastralEmpresaCnpj.natureza_juridica ? cadastralEmpresaCnpj.natureza_juridica.codigo + ' - ' + cadastralEmpresaCnpj.natureza_juridica.nome : ''} />
            <Description key={'porte_empresa'} label={t('porte')} value={cadastralEmpresaCnpj.porte_empresa} />
            <Description key={'email'} label={t('email')} value={cadastralEmpresaCnpj.email} />
            <Description key={'mei'} label={t('mei')} value={cadastralEmpresaCnpj.mei.mei ? 'Sim' : 'Não'} />
            <Description key={'simples'} label={t('simples')} value={cadastralEmpresaCnpj.simples.optante ? 'Sim' : 'Não'} />
            <Description key={'capital'} label={t('capitalSocial')} value={cadastralEmpresaCnpj.capital_social ? formatarParaMoedaBRL(Number(String(cadastralEmpresaCnpj.capital_social).replace(/(\d+)(\d{2})$/, '$1.$2'))) : 'Não informado'} />
          </div>
          <div className={styles.gridContainer} style={{ gridTemplateColumns: 'repeat(2, 1fr)', marginTop: '24px' }}>
            {cadastralEmpresaCnpj.atividades && cadastralEmpresaCnpj.atividades.principal && (
              <>
                {cadastralEmpresaCnpj.atividades.principal.map((atividade: any, index: number) => (
                  <Description key={atividade.codigo} label={t('atividadePrincipal') + ' ' + (index + 1)} value={atividade.codigo + ' - ' + atividade.nome} />
                ))}
              </>
            )}
            {cadastralEmpresaCnpj.atividades && cadastralEmpresaCnpj.atividades.secundaria && (
              <>
                {cadastralEmpresaCnpj.atividades.secundaria.map((atividade: any, index: number) => (
                  <Description key={atividade.codigo} label={t('atividadeSecundaria') + ' ' + (index + 1)} value={atividade.codigo + ' - ' + atividade.nome} />
                ))}
              </>
            )}
          </div>

        </div>
        {cadastralEmpresaCnpj.endereco && (
          <div>
            <br></br>
            <Divider align="left">
              <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z" /><path d="M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2" /><path d="M18 22v-3" /><circle cx="10" cy="10" r="3" /></svg>
                <span style={{ paddingLeft: '0.5rem' }}>
                  <b>Endereço</b>
                </span>
              </div>
            </Divider>
            <div className={styles.wrapper}>
              <div className={styles.gridContainer}>
                <Description key={'logradouro'} label={t('logradouro')} value={cadastralEmpresaCnpj.endereco.logradouro} />
                <Description key={'numero'} label={t('numero')} value={cadastralEmpresaCnpj.endereco.numero} />
                <Description key={'complemento'} label={t('complemento')} value={cadastralEmpresaCnpj.endereco.complemento} />
                <Description key={'bairro'} label={t('bairro')} value={cadastralEmpresaCnpj.endereco.bairro} />
                <Description key={'cep'} label={t('cep')} value={cadastralEmpresaCnpj.endereco.cep} />
                <Description key={'cidade'} label={t('cidade')} value={cadastralEmpresaCnpj.endereco.cidade.nome} />
                <Description key={'uf'} label={t('uf')} value={cadastralEmpresaCnpj.endereco.estado.sigla} />
              </div>

            </div>

          </div>
        )}
        {cadastralEmpresaCnpj.telefones && (
          <div>
            <br></br>
            <Divider align="left">
              <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /><path d="M14.05 2a9 9 0 0 1 8 7.94" /><path d="M14.05 6A5 5 0 0 1 18 10" /></svg>
                <span style={{ paddingLeft: '0.5rem' }}>
                  <b>Telefones</b>
                </span>
              </div>
            </Divider>
            <br></br>
            <DataTable size="small" value={cadastralEmpresaCnpj.telefones} tableStyle={{ minWidth: '50rem' }}>
              <Column field="telefone" header={t('fone')}></Column>
              <Column field="tipo" header={t('tipo')}></Column>
            </DataTable>
          </div>
        )}
        {cadastralEmpresaCnpj.socios && (
          <div>
            <br></br>
            <Divider align="left">
              <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2', }}><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" /><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" /><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" /><path d="M10 6h4" /><path d="M10 10h4" /><path d="M10 14h4" /><path d="M10 18h4" /></svg>
                <span style={{ paddingLeft: '0.5rem' }}>
                  <b>Sócios</b>
                </span>
              </div>
            </Divider>
            <br></br>
            <DataTable size="small" value={cadastralEmpresaCnpj.socios} tableStyle={{ minWidth: '50rem' }}>
              <Column field="cnpj_cpf" header={t('documento')}></Column>
              <Column field="nome" header={t('nome')}></Column>
              <Column field="funcao.descricao" header={t('cargo')}></Column>
              <Column field="faixa_etariia" header={t('faixaEtaria')}></Column>
              <Column body={formatarData} header={t('dataEntrada')}></Column>
            </DataTable>
          </div>
        )}
      </div>




    </Panel>
  );
}
